import { render } from "./EauthEventos.vue?vue&type=template&id=dc337da4&scoped=true"
import script from "./EauthEventos.vue?vue&type=script&lang=js"
export * from "./EauthEventos.vue?vue&type=script&lang=js"

import "./EauthEventos.vue?vue&type=style&index=0&id=dc337da4&scoped=true&lang=css"

import exportComponent from "F:\\Projetos VueJs\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc337da4"]])

export default __exports__